<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="店铺名称：" prop="shop_name">
                <span>{{model.shop_name}}</span>
            </el-form-item>
            <el-form-item label="城市：" prop="city">
                <span>{{model.city}}</span>
            </el-form-item>
            <el-form-item label="车型：" prop="model">
                <span>{{model.model}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="电话：" prop="phone">
                <span>{{model.phone}}</span>
            </el-form-item>
            <el-form-item label="服务内容：" prop="service">
                <span>{{model.service}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'shopSendInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                shop_id: '',
                shop_name: '',
                city: '',
                model: '',
                name: '',
                phone: '',
                service: '',
                add_time: '',
                creator: '',
            },
            getObj:{
                url:'/api/admin/shopsend/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>